import { render } from "./LastObjectCard.vue?vue&type=template&id=569e557f&scoped=true"
import script from "./LastObjectCard.vue?vue&type=script&lang=js"
export * from "./LastObjectCard.vue?vue&type=script&lang=js"

import "./LastObjectCard.vue?vue&type=style&index=0&id=569e557f&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-569e557f"]])

export default __exports__